import { Link } from "react-router-dom";

import "./index-info-contracting-terms-conditions.css"

export default function InfoContractingTermsConditions({
  children,
  variant,
  className,
  ...rest
}) {
  
    return (
    <>
      <div className="ep-info-contracting-terms-conditions">
        <strong>Precisa de orientação?</strong>{" "}
        <span>
          Entre em contato para descobrir qual modalidade faz mais sentido para
          seu objetivo.
        </span>{" "}
        <Link to="/termos-de-contratacao">Ver condições de contratação</Link>
      </div>
    </>
  );
}
